import Image from "next/image";
import { useT } from "@/app/translations/useT";
import { HomeRole } from "@/app/types/home/HomeRole";
import { FOR_WHO_PHOTO_HEIGHT, FOR_WHO_PHOTO_WIDTH } from "../ForWho.logic";
import styles from "../ForWho.module.css";

type Props = {
  role: HomeRole;
};

export default function ForWhoReading(props: Props) {
  const { role } = props;
  const T = useT();

  return (
    <li className={styles.reading}>
      <Image
        className={styles.photo}
        src={role.photo}
        alt=""
        width={FOR_WHO_PHOTO_WIDTH}
        height={FOR_WHO_PHOTO_HEIGHT}
        unoptimized
      />
      <div className={styles.readingBody}>
        <h3 className={styles.readingTitle}>{T(role.titleKey)}</h3>
        <p className={styles.readingText}>{T(role.textKey)}</p>
      </div>
    </li>
  );
}
